import { boot } from 'quasar/wrappers';
import { createI18n, type I18nOptions } from 'vue-i18n';
import messages from 'src/i18n';
import numberFormats from 'src/i18n/numberFormats';

export type MessageLanguages = keyof typeof messages;
// Type-define 'en-GB' as the master schema for the resource
export type MessageSchema = (typeof messages)['en-GB'];

// define number format schema for Vue component
export type NumberSchema = {
  currency: {
    style: 'currency';
    currencyDisplay: 'symbol';
    currency: string;
  };
};

// See https://vue-i18n.intlify.dev/guide/advanced/typescript.html#global-resource-schema-type-definition
/* eslint-disable @typescript-eslint/no-empty-interface */
declare module 'vue-i18n' {
  // define the locale messages schema
  export interface DefineLocaleMessage extends MessageSchema {}

  // define the datetime format schema
  export interface DefineDateTimeFormat {}

  // define the number format schema
  export interface DefineNumberFormat {
    currency: {
      style: string;
      currencyDisplay: string;
      currency: string;
    };
  }
}

const defaultLocale = 'en-GB';

const options: I18nOptions = {
  legacy: false, // you must set `false`, to use Composition API
  locale: defaultLocale,
  messages: messages,
  numberFormats: numberFormats,
};

/**
 * setup vue-i18n with i18n resources with global type definition.
 * if you define the i18n resource schema in your `*.d.ts`, these is checked with typeScript.
 */
const i18n = createI18n<false, typeof options>(options);

export default boot(({ app }) => {
  // Set i18n instance on app

  app.use(i18n);
});

export { i18n };
